import { Typography, ListItemText } from '@mui/material';
import List from '../styled/List';
import ListItemIcon from '../styled/ListItemIcon';
import ListItem from '../styled/ListItem';
import { pageLink } from '../utils/urls';

const Safety = () => (
  <>
    <Typography variant="h5" fontWeight="700" textTransform="none">
      6. Bezpieczeństwo.
    </Typography>
    <List>
      <ListItem>
        <ListItemIcon>6.1.</ListItemIcon>
        <ListItemText>
          Dane Użytkowników są chronione zgodnie z obowiązującymi przepisami
          prawa, poprzez zabezpieczenia techniczne i elektroniczne, polegające
          m.in. na szyfrowaniu połączeń z Serwisem za pomocą protokołu SSL oraz
          przez rozwiązania i procedury zapobiegające przed dostępem do danych
          osobowych Użytkowników przez osoby nieuprawnione.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>6.2.</ListItemIcon>
        <ListItemText>
          Użytkownik zobowiązany jest do zachowania wszelkich niezbędnych
          środków ostrożności mających zapobiec nieuprawnionemu uzyskaniu przez
          osobę trzecią danych służących do logowania do Serwisu i nie
          udostępniania ich osobom trzecim.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>6.3.</ListItemIcon>
        <ListItemText>
          Administrator zaleca, aby Użytkownik stosował się do następujących
          zasad bezpieczeństwa:
          <List>
            <ListItem>
              <ListItemIcon>a) </ListItemIcon>
              <ListItemText>
                korzystał z legalnego i na bieżąco aktualizowanego systemu
                operacyjnego na urządzeniu wykorzystywanym do dostępu do
                Serwisu,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon> b)</ListItemIcon>
              <ListItemText>
                korzystał z oprogramowania antywirusowego,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>c) </ListItemIcon>
              <ListItemText>
                unikał korzystania z dostępu do Internetu za pośrednictwem tzw.
                sieci publicznych (ogólnie dostępnych), a jeśli jest to
                konieczne – stosował rozwiązania klasy VPN przed zalogowaniem
                się do Serwisu,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>d) </ListItemIcon>
              <ListItemText>
                uważnie czytał ostrzeżenia i komunikaty wysyłane przez
                przeglądarkę, które mogą pojawiać się podczas korzystania z
                Internetu,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>e) </ListItemIcon>
              <ListItemText>
                przed zalogowaniem do Serwisu, sprawdzał, czy połączenie z
                Serwisem następuje z wykorzystaniem szyfrowania SSL oraz
                zweryfikował, czy certyfikat bezpieczeństwa wystawiony jest dla
                {pageLink},
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>f) </ListItemIcon>
              <ListItemText>
                chronił dostęp do urządzenia, na którym korzysta z Serwisu, za
                pomocą hasła, kodu PIN lub biometrii,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon> g)</ListItemIcon>
              <ListItemText>
                zachował ostrożność przy instalowaniu oprogramowania nieznanego
                pochodzenia,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>h) </ListItemIcon>
              <ListItemText>
                zachował w poufności Login i Hasło umożliwiające dostęp do
                Serwisu,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>i)</ListItemIcon>
              <ListItemText>
                nie używał tego samego hasła do logowania się do Serwisu i
                innych usług i portali internetowych.
              </ListItemText>
            </ListItem>
          </List>
        </ListItemText>
      </ListItem>
    </List>
  </>
);

export default Safety;
